import React, { FC } from 'react';
import { GenericGridTableHead } from '../../shared/components';

interface GenericTableHeadProps {
  labels?: Record<string, string>;
  headerFields: string[];
  sorter: (field: string) => void;
}

const GenericTableHead: FC<GenericTableHeadProps> = ({ labels, sorter, headerFields }) => {
  return (
    <thead>
      <tr>
        {headerFields &&
          headerFields.map(header => {
            return (
              <GenericGridTableHead
                label={labels[header]}
                sorter={sorter}
                field={header}
                key={header}
              />
            );
          })}
      </tr>
    </thead>
  );
};

GenericTableHead.displayName = 'GenericTableHead';
export default GenericTableHead;
